import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { DollarSign, Percent } from 'lucide-react';

interface CommissionSummaryCardProps {
  totalCommission: number;
  commissionRate: number;
  pendingCommission: number;
  paidCommission: number;
  period: string;
}

const CommissionSummaryCard = ({
  totalCommission,
  commissionRate,
  pendingCommission,
  paidCommission,
  period,
}: CommissionSummaryCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">
          Commission Summary
        </CardTitle>
        <CardDescription>For {period}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
          <div className="flex items-center gap-2">
            <DollarSign className="h-4 w-4 text-blue-600" />
            <span className="text-sm text-muted-foreground">
              Total Commission
            </span>
          </div>
          <span className="text-lg font-bold text-blue-600">
            ${totalCommission.toLocaleString()}
          </span>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-2 p-3 bg-green-50 rounded-lg">
            <DollarSign className="h-4 w-4 text-green-600" />
            <div>
              <p className="text-xs text-muted-foreground">Paid</p>
              <p className="text-sm font-semibold text-green-600">
                ${paidCommission.toLocaleString()}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-3 bg-yellow-50 rounded-lg">
            <DollarSign className="h-4 w-4 text-yellow-600" />
            <div>
              <p className="text-xs text-muted-foreground">Pending</p>
              <p className="text-sm font-semibold text-yellow-600">
                ${pendingCommission.toLocaleString()}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between p-3 bg-purple-50 rounded-lg">
          <div className="flex items-center gap-2">
            <Percent className="h-4 w-4 text-purple-600" />
            <span className="text-sm text-muted-foreground">
              Commission Rate
            </span>
          </div>
          <span className="text-lg font-bold text-purple-600">
            {commissionRate}%
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default CommissionSummaryCard;
